import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";

import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";

import { startAlerta } from "../../../../actions/ui/alertas";
import { getTiposNotasTodasEmpadronamiento, postNotasMedicacion } from "../../../../actions/empadronamiento/Empadronamiento";
import { EMPADRONAMIENTO_TIPOS_NOTAS } from "../../../../utils/constants";

export const ModalNotasMedicacion = (props) => {
  const dispatch = useDispatch();

  const { tiposNotasEmp = [] } = useSelector((state) => state.empadronamiento);
  const { idUsuario } = useSelector((state) => state.auth);

  const [idTipoNota, setIdTipoNota] = useState(props.nota?.idTipoNota ?? props.tipoNota);
  const [descripcion, setDescripcion] = useState(!!props.nota ? props.nota.descripcion : "");
  const error = false;

  useEffect(() => {
    dispatch(getTiposNotasTodasEmpadronamiento());
  }, []);

  const onChangeTextAreaHandler = (e) => {
    setDescripcion(e.target.value);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (descripcion.length === 0) {
      dispatch(startAlerta(`Debe completar la Nota`, "warning"));
    } else if (descripcion.length > 500) {
      dispatch(startAlerta(`La Nota puede tener un Max de 500 caracteres`, "warning"));
    } else if (!props.tipoNotaDisabled && idTipoNota === "") {
      dispatch(startAlerta(`Debe indicar el tipo de Nota`, "warning"));
    } else {
      let nota = null;
      if (!props.nota) {
        nota = {
          idSolicitud: props.idSolicitud,
          idTipoNota: idTipoNota,
          descripcion,
        };
      } else {
        nota = {
          idNota: props.nota?.idNota,
          descripcion,
        };
      }

      const method = !props.nota ? "POST" : "PUT";
      dispatch(postNotasMedicacion(nota,
        props.idSolicitud,
        method,
        props.close,
        props.idEstadoSolicitud,
        //idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.DEVOLUCION ? true : false,
        idTipoNota,
        props.setOpenModalGestionar));

      if (props.privada === true) {
        props.guardar();
      }
    }

  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={2} lg={3} />
            <Grid item xs={10} sm={10} md={8} lg={6}>
              {Array.isArray(tiposNotasEmp) && tiposNotasEmp?.length > 0 && (
                <SelectValidator
                  fullWidth
                  label="Tipo de Nota"
                  name="idTipoNota"
                  value={idTipoNota}
                  disabled={!!props.nota || props.tipoNotaDisabled}
                  onChange={(e) => setIdTipoNota(e.target.value)}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                >
                  {Array.isArray(tiposNotasEmp) &&
                    tiposNotasEmp?.length > 0 &&
                    tiposNotasEmp
                      .filter((tipoNota) => (props.privada ? tipoNota.idTipoNota === 1 : true))
                      .map((tipoNota) => (
                        <MenuItem key={tipoNota.idTipoNota} value={tipoNota.idTipoNota}>
                          {tipoNota.descripcion}
                        </MenuItem>
                      ))}
                </SelectValidator>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={2} lg={3} />
          </Grid>
          <Grid container spacing={2} style={{ margin: "2rem 0" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                label="Nota"
                name="descripcion"
                value={descripcion}
                disabled={
                  props.desdeIngresoSolicitud && props.titulo !== "Agregar Nota"
                }
                onChange={onChangeTextAreaHandler}
                error={error}
                helperText={error && "Este campo es requerido"}
              />
            </Grid>
          </Grid>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" disabled={props.disabled || (idTipoNota !== EMPADRONAMIENTO_TIPOS_NOTAS.PRIVADA && props.nota) || (idUsuario !== props.nota?.idUsuario && props.nota?.idUsuario !== undefined)} color="primary">
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};